import React from 'react'

export const Divider = ({className='mx-4'}) => (
    <div className={`h-1/2 border bg-primary-contrast-color-text my-auto ${className} opacity-30`}></div>
)